import { actionDescriptors } from "./actions";

const reducer = (state, action) => {
  switch (action.type) {
    case actionDescriptors.resetMessage:
      return {
        ...state,
        message: null
      };
    case actionDescriptors.setMessage:
      return {
        ...state,
        message: action.message
      };
    case actionDescriptors.getProperties:
      return {
        ...state,
        isPropertiesLoading: true,
      };
    case actionDescriptors.getPropertiesSuccessful:
      return {
        ...state,
        properties: action.payload,
        isPropertiesLoading: false
      };
    case actionDescriptors.getPropertiesFailed:
      return {
        ...state,
        error: action.error,
        isPropertiesLoading: false,
      };
    case actionDescriptors.getProperty:
      return {
        ...state,
        isPropertyLoading: true,
      };
    case actionDescriptors.getPropertySuccessful:
      return {
        ...state,
        property: action.payload,
        isPropertyLoading: false
      };
    case actionDescriptors.getPropertyFailed:
      return {
        ...state,
        error: action.error,
        isPropertyLoading: false
      };
    case actionDescriptors.postContact:
      return {
        ...state,
        isPostContactSubmitting: true
      };
    case actionDescriptors.postContactSuccessful:
      return {
        ...state,
        contact: action.payload,
        isPostContactSubmitting: true
      };
    case actionDescriptors.postContactFailed:
      return {
        ...state,
        error: action.error,
        isPostContactSubmitting: false
      };
    case actionDescriptors.postNewsletterContact:
      return {
        ...state,
        isNewsletterContactSubmitting: true
      };
    case actionDescriptors.postNewsletterContactSuccessful:
      return {
        ...state,
        newsletterContact: action.payload,
        isNewsletterContactSubmitting: false
      };
    case actionDescriptors.postNewsletterContactFailed:
      return {
        ...state,
        error: action.error,
        isNewsletterContactSubmitting: false
      };
    case actionDescriptors.postReview:
      return {
        ...state,
        isReviewSubmitting: true
      };
    case actionDescriptors.postReviewSuccessful:
      return {
        ...state,
        review: action.payload,
        isReviewSubmitting: false
      };
    case actionDescriptors.postReviewFailed:
      return {
        ...state,
        error: action.error,
        isReviewSubmitting: false
      };
    case actionDescriptors.getReviews:
      return {
        ...state,
        isReviewsLoading: true
      };
    case actionDescriptors.getReviewsSuccessful:
      return {
        ...state,
        reviews: action.payload,
        isReviewsLoading: false
      };
    case actionDescriptors.getReviewsFailed:
      return {
        ...state,
        error: action.error,
        isReviewsLoading: false
      };
    default:
      throw new Error(`Unhandled action: '${action.type}'`);
  }
};

export default reducer;
